import { render, staticRenderFns } from "./VirtualList.vue?vue&type=template&id=65d37ac4&scoped=true"
import script from "./VirtualList.vue?vue&type=script&lang=ts"
export * from "./VirtualList.vue?vue&type=script&lang=ts"
import style0 from "./VirtualList.vue?vue&type=style&index=0&id=65d37ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d37ac4",
  null
  
)

export default component.exports